import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "14",
  height: "14",
  fill: "none",
  viewBox: "0 0 14 14"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M3.922.91c1.833.028 2.545 1.623 2.78 2.375.023.076.174.076.197 0C7.133 2.533 7.845.938 9.68.91c2.4-.037 4.206 2.659 2.559 5.365C10.77 8.687 6.855 13.09 6.8 13.09c-.056 0-3.97-4.402-5.438-6.815C-.285 3.57 1.52.873 3.922.91"
    }, null, -1)
  ])))
}
export default { render: render }